import React, { useEffect, useState } from 'react';
import Phone from '../../../../ui-core/Phone';
import { grecaptcha } from '../../../../services/recaptcha';
import {
  // doSignupRequest,
  doUpdateWithOtpRequest,
} from '../../../../store/action/auth';
import phone from 'phone';
import { useDispatch, useSelector } from 'react-redux';
// import { SEGMENT_EVENTS, trackEvent } from '../../../../utils/Segment';
import Button from '../../../../ui-core/Button/Button';
import { LOCAL_STORAGE_CONSTANT, MODAL_TYPE } from '../../../../constants/app';
import PropTypes from 'prop-types';
import { doUpdateUserProfieRequest } from '../../../../store/action/user';
import { getItem, removeItem, setItem } from '../../../../utils/cache';
import { extractJSON } from '../../../../services/jsonUtil';
import Ref from '../../../../ui-core/Ref';
import { SEGMENT_EVENTS, trackEvent } from '../../../../utils/Segment';
import { checkForUniqueness } from '../../../../api/user';
import {
  createNotification,
  NOTIFICATION_TYPE,
} from '../../../../services/Notification';
import { useModal } from '../../../../context/ModalContext';
import { APP_ROUTES } from '../../../../route';
import { useHistory } from 'react-router-dom/cjs/react-router-dom.min';
import { getUserAttribute } from '../../../../utils/helpers';
import { useCourseDetail } from '../../../../hooks/useCourseDetail';
import { processOfflineCart } from '../../../../utils/offlineCart';
import {
  clearJoinDeepLinkFlowFlag,
  initiateJoinDeepLinkMembershipCheckout,
  isJoinDeepLinkPurchaseIntent,
} from '../../../../utils/joinDeepLinkPurchase';

const PhoneModal = props => {
  // const SignUpData = JSON.parse(localStorage.getItem('SignUpData'));
  const history = useHistory();
  const { openModal } = useModal();
  const [postData, setPostData] = useState({
    mobile: null,
    country_code: null,
  });
  const [isValidNumber, setValidNumber] = useState(false);
  const { isLoading } = useSelector(state => state.common);
  const [error, setError] = useState({ hasError: false, message: '' });
  const [, setBtnVisible] = useState({
    isVisible: false,
  });
  const dispatch = useDispatch();
  const { handleModalState, countryCode } = props;
  const user = extractJSON(LOCAL_STORAGE_CONSTANT.USER);
  const sessiondata = JSON.parse(getItem(LOCAL_STORAGE_CONSTANT.SESSION));
  const urlParams = new URLSearchParams(window.location.search);
  const uid = urlParams.get('uid');
  const provider = urlParams.get('provider') || sessiondata?.provider;
  const social_token = urlParams.get('access_token');
  const isAppleLogin = getItem('isAppleLogin');
  const isConfirmPhoneModal = getItem('AccountMerge');
  // const isNotNowClicked = getItem("NotNowClicked");
  const localMatch = getItem('localMatch');
  const { handleCourseRedirection } = useCourseDetail(history, localMatch);

  useEffect(() => {
    if (isConfirmPhoneModal) {
      handleModalState(null);
    }
  }, [isConfirmPhoneModal]);

  const handlePhoneOnChange = (phoneNumber, countryCode, countryData) => {
    const validData = phone(
      `${countryCode}${phoneNumber?.replace(/\D+/g, '')}`,
      { country: countryData?.countryCode?.toUpperCase() },
    );
    setValidNumber(validData.isValid);
    setPostData({
      mobile: phoneNumber?.replace(/\D+/g, ''),
      country_code: countryCode,
    });
    if (phoneNumber[0] === '0') {
      setError({
        ...error,
        hasError: true,
        message: '0 cannot be the first digit of your mobile number.',
      });
    } else if (phoneNumber[0] === '(' && phoneNumber[1] === '0') {
      setError({
        ...error,
        hasError: true,
        message: '0 cannot be the first digit of your mobile number.',
      });
    } else if (!validData.isValid) {
      setError({
        ...error,
        hasError: true,
        message: 'Please enter a valid number.',
      });
    } else {
      setError({ ...error, hasError: false, message: '' });
    }
  };

  const checkUniqueMobile = async () => {
    try {
      const payload = {
        type: 'mobile',
        mobile: postData?.mobile,
        country_code: postData?.country_code,
      };
      const response = await checkForUniqueness(payload);
      return response.data;
    } catch (error) {
      return error?.response?.data?.response?.errors[0] || error?.message;
    }
  };

  const handlePhoneOnSubmit = async e => {
    e.preventDefault();

    const error = await checkUniqueMobile();
    if (error) {
      const phoneDetails = {
        mobile: postData?.mobile,
        country_code: postData?.country_code,
      };
      setItem('mergePhoneDetail', JSON.stringify(phoneDetails));
      createNotification({
        type: NOTIFICATION_TYPE.ERROR,
        message: error,
      });
      openModal(MODAL_TYPE.CONFIRM_PHONE_NUMBER);
    } else {
      grecaptcha.execute(token => {
        // trackSubmittedEvent('Sign up submit', {
        //   page: 'Home Page',
        //   section_title: 'Signup Modal',
        //   button_title: 'SEND VERIFICATION CODE',
        //   phone: postData?.mobile,
        //   country_code: postData?.country_code,
        // });
        if (provider || isAppleLogin) {
          localStorage?.setItem('SocialLoginData', JSON.stringify(postData));
          const session = extractJSON(LOCAL_STORAGE_CONSTANT.SESSION);
          const data = {
            ...postData,
            name: user?.attributes?.name || '',
            // email: uid || session?.uid,
            email: user?.attributes?.email || uid || session?.uid,
            token: social_token || session?.access_token,
            user_profile_attributes: {
              goal: '',
              tried_solutions: '',
              exercise_frequency: '',
              time_per_day: '',
              preferred_part_of_day: '',
            },
          };
          dispatch(
            doUpdateWithOtpRequest({
              data: {
                ...postData,
              },
              callback: () => {
                // handleModalState(MODAL_TYPE.OTP);
                dispatch(
                  doUpdateUserProfieRequest({
                    data,
                    callback: () => {
                      setItem('isPhoneVerified', true);
                      handleModalState(MODAL_TYPE.OTP);
                    },
                  }),
                );
              },
              page: props.page,
            }),
          );
          // dispatch(
          //   doUpdateUserProfieRequest({
          //     data,
          //     callback: () => {
          //       setItem('isPhoneVerified', true);
          //       handleModalState(MODAL_TYPE.OTP);
          //     },
          //   }),
          // );
        } else {
          // dispatch(
          //   doSignupRequest({
          //     data: {
          //       ...postData,
          //       email: SignUpData?.email,
          //       password: SignUpData?.password,
          //       email_signup: true,
          //       type: 'signup',
          //       token,
          //     },
          //     callback: () => handleModalState(MODAL_TYPE.OTP),
          //     page: props.page,
          //   }),
          // );
          dispatch(
            doUpdateWithOtpRequest({
              data: {
                ...postData,
              },
              callback: () => {
                handleModalState(MODAL_TYPE.OTP);
              },
              page: props.page,
            }),
          );
        }

        // trackDisplayedEvent('Display OTP Modal', {
        //   page: 'Home Page',
        //   section_title: 'OTP Modal',
        // });
      });
    }
  };

  const handleKeyDown = event => {
    if (event.keyCode === 13 && isValidNumber) handlePhoneOnSubmit(event);
  };

  const handleLoginClick = () => {
    handleModalState(MODAL_TYPE.LOGIN);
    trackEvent(SEGMENT_EVENTS.BUTTON_CLICKED, {
      // eslint-disable-line
      button_title: 'Login Now',
      page: props.page || 'Home Page',
      section_title: `Phone Modal`,
    });
    // trackDisplayedEvent('Display Login Modal', {
    //   page: 'Home Page',
    //   section_title: 'Login Modal',
    // });
  };

  const handleSkip = async () => {
    const isFromCoursePage = getItem('isFromCoursePage');
    const onboardingCompleted = extractJSON('completeOnboarding');
    const isOnboardingCompleted = getUserAttribute('onboarding_completed');
    const isOfflineCheckout = JSON.parse(getItem('isOfflineCheckout'));
    const isJoinDeepLinkFlow = isJoinDeepLinkPurchaseIntent();

    const clearCourseRedirectKeys = () => {
      clearJoinDeepLinkFlowFlag();
      removeItem('redirectToCourse');
      removeItem('localMatch');
      removeItem('localSlug');
    };

    if (
      !isFromCoursePage &&
      !isOfflineCheckout &&
      initiateJoinDeepLinkMembershipCheckout(dispatch, history)
    ) {
      handleModalState(null);
      return;
    }

    if (!isFromCoursePage) {
      if (onboardingCompleted) {
        history?.push(APP_ROUTES.ASSESSMENT_ONBOARDING);
      } else {
        if (isOfflineCheckout) {
          processOfflineCart({ dispatch });
        } else if (isOnboardingCompleted) {
          history?.push(APP_ROUTES.HOME);
        } else {
          // handleModalState(MODAL_TYPE.ASSESSMENT);
          history?.push(APP_ROUTES.SIGNUP_ONBOARDING);
        }
      }
    }

    const localUser = extractJSON(LOCAL_STORAGE_CONSTANT.USER);
    const session = extractJSON(LOCAL_STORAGE_CONSTANT.SESSION);
    const isRedirectCourse = getItem('redirectToCourse');
    const isFromLogin = getItem('isFromLogin');
    if (session) {
      if (isRedirectCourse || isFromCoursePage) {
        if (
          localUser?.attributes?.new_user &&
          isFromLogin === 'false' &&
          !isJoinDeepLinkFlow
        ) {
          handleModalState(MODAL_TYPE.NAME);
          // removeItem('isFromLogin');
        } else {
          await handleCourseRedirection();
          clearCourseRedirectKeys();
        }
      }
    }
    removeItem('redirectToCourse');
    removeItem('localMatch');
    removeItem('localSlug');
    // removeItem('isFromCoursePage');
    trackEvent(SEGMENT_EVENTS.BUTTON_CLICKED, {
      // eslint-disable-line
      button_title: 'Skip for now',
      page: props.page || 'Home Page',
      section_title: `Phone Modal`,
    });
  };

  return (
    <>
      <div className="form-h">
        <h2 className="sign-in-h1">Enter Phone Number </h2>
        <p className="sign-in-h3 mb-4 mt-4 pb-3">
          Simplify your sign-in process by adding your phone number.
        </p>
        <div className="mb-2">
          <span className="text-uppercase">Phone Number</span>
        </div>
        <Phone
          countryCode={countryCode}
          handleOnChange={handlePhoneOnChange}
          setBtnVisible={setBtnVisible}
          onKeyDown={handleKeyDown}
        />
        <div>
          <span className="text-danger error-text w-100">
            {error.hasError ? error.message : ''}
          </span>
        </div>
        <div className="mt-5 text-center">
          <span className="skip-content" onClick={() => handleSkip()}>
            Skip for now
          </span>
        </div>
        <Button
          text="CONTINUE"
          class={`OtpButton ${isLoading && ''}`}
          isDisabled={isLoading || !isValidNumber}
          isLoading={isLoading}
          onClick={handlePhoneOnSubmit}
        />
        {user?.attributes?.mobile && (
          <div className="d-flex align-items-center justify-content-center signin-bottom-row mt-4">
            <h3 className="head3 m-0"> Already a member ? </h3>
            <Ref
              class="signup-link fz20 ms-2"
              onClick={() => handleLoginClick()}
              text="Login Now"
            />
          </div>
        )}
      </div>
    </>
  );
};

PhoneModal.propTypes = {
  countryCode: PropTypes.string,
  handleModalState: PropTypes.func,
  page: PropTypes.string,
  plan_id: PropTypes.string,
};

export default PhoneModal;
